export default __webpack_public_path__ + "static/moc-1-2-7b81827eefef08c63961e9df79c070f8.png";